// extracted by mini-css-extract-plugin
export var externalLink = "_cr-0";
export var internalLinkLabel = "_cr-1";